
const getProfileOverviewFieldValue = (inputId) => ($('#profile-overview').find(`#${inputId}`).val() || '').trim()

const profileHandle = (inputId) => {
    const v = getProfileOverviewFieldValue(inputId).replace(/^@+/, '')
    return v ? '@' + v : ''
}

$('#profile-overview__save-button').click(async (e) => {
    const T = window.bspText || { error: 'Error', ok: 'Saved', saving: '…', save: 'Save' }
    e.preventDefault()
    const button = $(e.currentTarget)
    const profileContainer = $('#profile-overview')
    const feedbackMessage = profileContainer.find('#profile-orverview__feedback-message')

    const showFeedback = (text, isError) => {
        feedbackMessage.text(text)
        feedbackMessage.removeClass('show error').addClass(isError ? 'show error' : 'show')
        clearTimeout(feedbackMessage.data('timer'))
        feedbackMessage.data('timer', setTimeout(() => feedbackMessage.removeClass('show error'), 5000))
    }

    const payload = {
        first_name: getProfileOverviewFieldValue('first-name'),
        last_name: getProfileOverviewFieldValue('last-name'),
        email: getProfileOverviewFieldValue('email'),
        phone: getProfileOverviewFieldValue('phone').replace(/[\s-]/g, ''),
        gender: getProfileOverviewFieldValue('gender'),
        instagram: profileHandle('instagram'),
        facebook: profileHandle('facebook'),
    }
    const query = new URLSearchParams({
        q: profileContainer.attr('data-customer-id'),
        t: profileContainer.attr('data-t'),
        sig: profileContainer.attr('data-sig'),
    })

    button.prop('disabled', true).text(T.saving)
    try {
        const response = await fetch('https://bussa.co.il/subscriptions/profile?' + query.toString(), {
            method: 'PUT',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
        if (!response.ok) throw new Error('HTTP ' + response.status)
        await response.json().catch(() => null)
        showFeedback(T.ok, false)
    } catch (err) {
        showFeedback(T.error, true)
    } finally {
        button.prop('disabled', false).text(T.save)
    }
})
